export default {
    data() {
        return {

        }
    },

    watch: {

    },

    created() {

    },

    methods: {
        openPage() {
            this.$emit('open')
        }
    }
}
